import React from "react";
import { Link } from "react-router-dom";

const FooterBottom: React.FC = () => {
  return (
    <section className="pt-8 mt-16 border-t">
      <div className="flex justify-between items-center max-sm:flex-col max-sm:gap-4">
        <p className="text-sm">
          © 2025 I Excel Management & Services. All rights reserved.
        </p>
        <nav className="flex gap-8 text-sm">
          <Link to="/terms" className="cursor-pointer hover:underline">Terms-and-conditions</Link>
          <Link to="/privacy" className="cursor-pointer hover:underline">Privacy-policy</Link>
        </nav>
        {/*<div className="flex gap-4">
          <a href="#" aria-label="Facebook">
            <i
              className="ti ti-brand-facebook text-base cursor-pointer"
              aria-hidden="true"
            />
          </a>
          <a href="#" aria-label="Instagram">
            <i
              className="ti ti-brand-instagram text-base cursor-pointer"
              aria-hidden="true"
            />
          </a>
          <a href="#" aria-label="YouTube">
            <i
              className="ti ti-brand-youtube text-base cursor-pointer"
              aria-hidden="true"
            />
          </a>
        </div>*/}
      </div>
    </section>
  );
};

export default FooterBottom;
